import { useEffect, useState } from "react";
import { Phone, ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after the hero section (approx 600px scroll)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-black/10 shadow-[0_-6px_18px_-6px_rgba(0,0,0,0.12)] px-3 py-2.5 flex gap-2"
      data-testid="sticky-cta-bar"
    >
      <a
        href="tel:+33141315061"
        data-testid="sticky-cta-call"
        className="flex-1 inline-flex items-center justify-center gap-1.5 border-2 border-[#1a2332]/15 text-[#1a2332] font-headings font-bold rounded-xl py-3 text-sm"
      >
        <Phone className="w-4 h-4" /> Appeler
      </a>
      <a
        href="#contact"
        data-testid="sticky-cta-signup"
        className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#FF8C42] text-white font-headings font-bold rounded-xl py-3 text-sm shadow-md"
      >
        S'inscrire <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
}
